export const TypeRate = {
    SAME_DAY_PENCE_PER_MILE_ONLY: 'Sameday pence per mile only',
    SAME_DAY_MIN_DISTANCE_PENCE_PER_MILE: 'Sameday min distance pence per mile',
    CONSIGNMENT_PLUS_KG: 'Consignment plus kg',
    PALLET: 'Pallet',
    PACKAGE: 'Package',
    PACKAGE_SURCHARGE: 'Package surcharge',
    PALLET_SURCHARGE: 'Pallet surcharge'
}